<template>
  <div id="customer">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">新增用户</el-button>
    </el-row>
    <el-form id="queryForm" :inline="true" :model="queryForm" class="demo-form-inline">
      <el-form-item label="用户名">
        <el-input v-model="queryForm.userName" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="queryForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData.list"
      style="width: 100%"
      :default-sort="{prop: 'date', order: 'descending'}"
      border
    >
      <el-table-column prop="userName" label="用户名"></el-table-column>
      <el-table-column prop="mobile" label="手机号" sortable></el-table-column>
      <el-table-column prop="locked" label="是否锁定"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit" /></el-button>
          <el-button size="mini" type="primary" @click="changePassword(scope.row)"><i class="el-icon-lock" /></el-button>
          <el-button size="mini" type="danger" @click="removeCustomer(scope.row)"><i class="el-icon-delete" /></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="query"
      @size-change="changeSize"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10,20,30,40,50]"
      :total="tableData.total"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog title="添加用户" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="form.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否锁定" :label-width="formLabelWidth">
          <el-switch v-model="form.locked" active-text="锁定" inactive-text="未锁定" inactive-value="0" active-value="1"></el-switch>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="new-password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth">
          <el-input v-model="form.confirmPassword" autocomplete="new-password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCustomer">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新客户" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-form :model="updateForm">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="updateForm.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="updateForm.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否锁定" :label-width="formLabelWidth">
          <el-switch v-model="updateForm.locked" active-text="锁定" inactive-text="未锁定" inactive-value="0" active-value="1"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCustomer">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: {}
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.query();
    },
    query() {
      var self = this;
      this.$axios
        .get("system/user/query", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveCustomer() {
      var self = this;
      this.$axios.post("system/user/save", self.form).then(function(response) {
        if (response.data.errorCode == "00000") {
          self.dialogFormVisible = false;
          //清空表单
          self.form = {};
          self.$message({
            message: "保存成功",
            type: "success"
          });
          self.query();
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    removeCustomer(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("system/user/remove/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
    },
    updateCustomer() {
      var self = this;
      this.$axios
        .post("system/user/update", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    }
  },
  created: function() {
    this.query();
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>